<template>
  <section class="products">
      <b-container fluid>
        <b-row class="justify-content-center title_box">
          <b-col
            cols="11"
            sm="10"
            md="9"
            xl="8"
            class="flex-column justify-content-center d-flex"
          >
            <div class="jian">
              <v-com_title :msg="hTitle[0]"></v-com_title>
            </div>
          </b-col>
        </b-row>
      </b-container>
      <b-container fluid   style="position: relative;" class="wrapself" >
        <div  class="temp_box  d-none d-sm-block" style="position: absolute;left: 17%;width: 23%;z-index: 9999;text-align: justify;cursor: pointer;" 
        @click="pushPage(itemObj.title)">
                <div class="timeLine" >{{ itemObj.timeLine }}</div>
                  <div class="title" >{{ itemObj.title }}</div>
                  <div class="sub" >{{ itemObj.sub }}</div>
                  <!-- <div class="sub" :class="{fadeInText:isShow}">{{ itemObj.sub }}</div> -->
        </div>
        <div class="temp_box  d-block d-sm-none" style="width: 80%;margin: 0 auto 20px;cursor: pointer;" @click="pushPage(itemObj.title)">
        <!-- <div class="temp_box  d-block d-sm-none" style="position: absolute;left: 5%;top: 2%;width: 80%;" > -->
                <div class="timeLine">{{ itemObj.timeLine }}</div>
                  <div class="title">{{ itemObj.title }}</div>
                  <div class="sub">{{ itemObj.sub }}</div>
        </div>
        <b-row class="justify-content-center container1" ref="wrapper" >
          <b-col  sm="12" class="flex-column justify-content-center"           
          >
          <!-- style="background-color: rgb(212, 123, 255);" -->
            
              <b-row
                class="justify-content-center brow"
                v-for="(item, i) in dataList"
                  :key="i"
              >
                <!-- 左边、上边 -->
                <b-col
                  cols="2"
                  sm="4"
                  class="yincang"
                >
                
                
                <!-- <div class="left_content d-block d-sm-none">
                  <div class="timeLine">{{ item.timeLine }}</div>
                  <div class="title">{{ item.title }}</div>
                  <div class="sub">{{ item.sub }}</div>
                </div> -->
                </b-col>
          
                <!-- 中间 竖线 -->
                <!-- <b-col cols="1" sm="2" class="text-center "> -->
                <b-col cols="1" sm="2" class="d-none d-sm-block text-center " >
                  <div class="verticalBar"></div>
                </b-col>
                <!-- 右边、下边 -->
                
                <b-col
                cols="11"
                sm="6"
                class="d-block d-xs-none img-box text-center"
                  :style="{ backgroundColor: item.c2 }"
                 
                >
                  <!-- {{ 2 * i + 2 }} -->
                  <img :src="item.img" alt="""></img>
                </b-col>
                <!-- 小屏时右边加一条竖线 -->
                <b-col
                  cols="1"
                  class="justify-content-center d-block d-sm-none d-flex plaine"
                  >
                  <!-- style="background-color: aqua;" -->
                  <div class="verticalBar"></div>
                 
                </b-col>
                   
                <!-- <b-col
                  cols="11"
                  sm="4"
                  :style="{ backgroundColor: item.c1 }"
                >
                  <div class="left_content">
                    <div class="timeLine">{{ item.timeLine }}</div>
                    <div class="title">{{ item.title }}</div>
                    <div class="sub">{{ item.sub }}</div>
                  </div>
                </b-col> -->
              
              </b-row>
           
          </b-col>
        </b-row>
        <!-- 飞机（大屏时显示 -->
        <div
          class="block d-none d-sm-block plaine"
          :style="{ bottom: blockBottom + 'px', left: t_left }"
          ></div>
          <!-- style="background-color: #ffc" -->
        <!-- :style="{ bottom: blockBottom + 'px', left: 'calc(44.5% - 25px)' }" -->
        <!-- :style="{ bottom: blockBottom + 'px', left: 'calc(50% - 25px)' }" -->
        <!-- 飞机（小屏时显示 -->
        <!-- (1*12/10+0.5)/(12*12/10)=11.8% -->
        <!-- style="background-color: #fcc;" -->
        <div
          class="block d-block d-sm-none"
          :style="{ bottom: blockBottom + 'px', right: 'calc(11% - 25px)' }"
        ></div>
      </b-container>

  </section>
</template>
<!-- npm install better-scroll -S -->
<script>
import BScroll from "better-scroll";
import { debounce } from 'lodash';
import Com_title from "../com-title";
export default {
  components: {
    "v-com_title": Com_title,
  },
  data() {
    return {
      hTitle: ["重点项目"],
      isShow:false,
      scroll: null,
      blockBottom: 0,
      // t_left: "calc(44.5% - 27.5px)",
      // (2*12/8+5)/(12*12/8)=44.4%
      t_left: "calc(44.6% - 25px)",
      screenWidth: 0,
      itemObj:{
          timeLine: "",
          title: "",
          sub: "",
          img:"",
      },
      // itemObj:{
      //     timeLine: "2021",
      //     title: "“民航e政”APP",
      //     sub: "2021年7月8日，民航局首个自主建设、安全可靠的移动综合办公平台——“民航e政”APP正式上线启动。该应用是以信息化为手段开启民航智慧政务建设、支撑行政办公转型的重要智能化举措，推动民航局行政办公从无纸化向移动化进阶、从电子化向智能化转型，是思维理念和工作方式的一次深刻变革，是用数字政府建设推进智慧民航发展的探索与实践。",
      // },
      dataList: [
      
        { 
          timeLine: "2021",
          title: "“民航e政”APP",
          sub: "2021年7月8日，民航局首个自主建设、安全可靠的移动综合办公平台——“民航e政”APP正式上线启动。该应用是以信息化为手段开启民航智慧政务建设、支撑行政办公转型的重要智能化举措，推动民航局行政办公从无纸化向移动化进阶、从电子化向智能化转型，是思维理念和工作方式的一次深刻变革，是用数字政府建设推进智慧民航发展的探索与实践。",
          img: require("@/assets/images/index/s_zdxm/E-img.png"),
        },
        { 
          timeLine: "2021",
          title: "适航管理系统（AMOS）",
          sub:"AMOS 系统深入贯彻“互联网+适航”的理念，构建了基于风险管理的审定模式，围绕辅助审定、审定管理、人员能力、证件管理四大业务，对我国适航体系进行优化、整合，建成了从设计、生产、改装、单机适航、部件审定、航空消耗品到部分持续适航的全链条管理，实现了适航审定的信息化、流程化和标准化，涵盖了适航领域内的全部23项行政许可管理。是民航局首个对接电子印章/证照和好差评的系统，也是业内首个全面国产化的政务系统。",
          img: require("@/assets/images/index/s_zdxm/AMOS-img.png"),
        },
        { 
          timeLine: "2021",
          title: "民用无人驾驶航空器综合管理平台（UOM）",
          sub:'为了落实国家《无人驾驶航空器飞行管理暂行条例》及民航局CCAC92部规章，按照“一网通办”的要求，UOM提供实名登记、操控员执照、适航审定、运营管理、空中交通服务管理等功能，与国家空中交通管理机构、工信、公安、市场监督总局等各单位实现信息协同，创新无人机协同监管模式，实现“飞起来、看得见、找得到”立体化、全方位的管控目标，为推动我国低空飞行服务的产业发展和应用、满足大众需求，提供安全服务和重要保障。',
          img: require("@/assets/images/index/s_zdxm/UOM-img.png"),
        },
        {
          timeLine: "2020",
          title: "民航政务信息系统整合共享项目",
          sub: "民航数据共享交换平台是民航局落实国务院“放管服”、“互联网+政务服务”、“互联网+监管”等工作精神的重要成果，消除了民航局内部、民航局与其它行政机构之间的数据共享交换障碍，实现了跨地区、跨层级、跨部门的数据共享交换，充分发挥民航政务数据资源共享交换枢纽作用。",
          img: require("@/assets/images/index/s_zdxm/zhgx-img.png"),
        },
        {
          timeLine:"2020",
          title:"民航行政审批服务平台",
          sub:"2020年，民航行政审批服务平台上线运行，平台按照民航局工作部署建设了服务门户（PC端/APP端/微信服务号）、工作门户、受理办理、事项库管理、“好差评”等7个功能模块，可为行政相对人提供全面、高效、统一的行政审批服务，并实现与国家一体化政务服务平台数据互通，为进一步提升民航局行政审批服务规范化便利化水平、提高办事效率提供强有力的信息化支撑。",
          img: require("@/assets/images/index/s_zdxm/govcheck.png"),
        },
        {
          timeLine:"2018",
          title:"民航价格管理系统",
          sub:"建立一套民航价格数据采集、整合、服务和管理的技术体系，及时准确掌握民航各类价格信息，为民航价格管理部门提供价格实时监测、预测、预警、监管、分析等支持，提高民航行业价格、收费执行情况监测能力，进一步加强民航价格及航空运输市场监管能力，增强和改善市场宏观调控能力，提高政府价格决策科学水平，促进民航行业持续健康有序发展。",
          img: require("@/assets/images/index/s_zdxm/price-img.png"),
        },
        {
          timeLine:"2018",
          title:"民航政务云服务平台",
          sub:"民航政务云平台实现了主中心和同城灾备中心计算、存储，网络资源的融合管理，平台具有CPU 8224核，内存27TB及存储420余TB，运行虚拟机900余台，具备了IAAS、PAAS以及容器等主流云平台功能，为民航新基建提供了基础算力。民航政务云平台实现了各政务系统在大平台集中运行，切实避免各自为政、重复投资、重复建设，为行业应用系统提供基础设施保障。未来将进一步打造成服务全行业、统筹共用、自主可控的国家级民行业云平台。",
          img: require("@/assets/images/index/s_zdxm/eservice-img.png"),
        },
        {
          timeLine:"2017",
          title:"民航综合统计信息系统",
          sub:`构建了民航统计大数据平台，实现对民航行政机关、企事业单位等综合统计资料的全面数据采集、处理、存储、分析、发布，充分发挥统计数据在民航高质量发展的决策支撑作用。
      系统采集机场、运输航空、通用航空等领域675个字段信息，实现统计数据资源整合；综合分析454个统计指标，反映航空运输市场发展趋势，为行业监管提供数据支撑；深挖数据价值，提供月报、年报、数据可视化、OLAP多维分析多种功能，充分满足灵活化分析需求；实现基础代码、业务规则、检验规则集中统一管理，大幅提升数据质量和运行效率。`,
          // sub:"构建了民航统计大数据平台，实现对民航行政机关、企事业单位等综合统计资料的全面数据采集、处理、存储、分析、发布，充分发挥统计数据在民航高质量发展的决策支撑作用。系统采集机场、运输航空、通用航空等领域675个字段信息，实现统计数据资源整合；综合分析454个统计指标，反映航空运输市场发展趋势，为行业监管提供数据支撑；深挖数据价值，提供月报、年报、数据可视化、OLAP多维分析多种功能，充分满足灵活化分析需求；实现基础代码、业务规则、检验规则集中统一管理，大幅提升数据质量和运行效率。",
          img: require("@/assets/images/index/s_zdxm/TOTAL-img.png"),
        },
        {
          timeLine: "2016",
          title: "民航行业监管执法系统SES",
          sub: "民航行业监管执法系统（SES）是贯彻落实“依法治国”方针的重要举措，该系统体现了民航行业监管模式的改革创新，实现了行政检查与法律支持的紧密结合，统一并规范了执法程序和法律文书格式等，为精准监管、智慧监管提供了有效的基础保障。",
          img: require("@/assets/images/index/s_zdxm/ses-img.png"),
        },
       
        {
          timeLine:"2016",
          title:"民航局政府网站",
          sub:"民航局政府网站包括中文版、英文版、移动客户端以及移动浏览器版，按照政府网站信息公开、办事服务、互动交流三大定位，不断优化政务信息公开栏目、完善行政审批平台、改善公众交流渠道、整合行业信息数据资源、优化站内智能检索、改进适老化及无障碍服务，打造民航局、各司局、各地区管理局、部分直属单位统筹集约管理的规模化网站群，提高政务服务智能化数字化服务能力，提升民航局公共服务水平。",
          img:require("@/assets/images/index/s_zdxm/GOV-img.png"),
        },
       
        {
          timeLine: "2014",
          title: "民用机场安全监管ASOP",
          sub: "民用机场安全监管（ASOP）系统实现民用机场使用许可、机场安全检查的全面电子化，该系统主要面向局方监察员、机场行政相对人等用户，支持机场飞行区快报、周报、月报的统一上报汇总，极大提升了机场安全管理效率和人员管控能力。",                     
          img: require("@/assets/images/index/s_zdxm/Asop-img.png"),
        },
        {
          timeLine: "2008",
          title: "飞行标准监督管理（FSOP）",
          sub:"飞行标准安全监管系统（FSOP）从航空器运营人监管、人员资质管理、航空器运营人支持保障体系监管三个方面，实现对飞标业务的全覆盖，是民航局首个业务系统。飞标日常监察工作、行政许可工作全部上网，FSOP是整个行业安全监管经验的总结和提炼，是落实持续安全理念的有力工具。其中飞行员云执照APP，使中国民航成为全球首家使用飞行员电子执照的国家，并已增加ICAO飞行员电子执照标准的国际版执照。",
          img: require("@/assets/images/index/s_zdxm/Fsop-img.png"),
        },
        
       
        
        
      ],
    };
  },

  mounted() {
    this.itemObj = {
        timeLine : this.dataList[0].timeLine,
        title : this.dataList[0].title,
        sub : this.dataList[0].sub,
    }
    this.screenWidth = window.innerWidth;
    this.setReSize();
    // 窗口大小发生改变时,调用一次
    window.onresize = () => {
      this.screenWidth = window.innerWidth;
      this.setReSize();
    };
    console.log("lll",this.$refs.wrapper);
    this.$nextTick(() => {
      if (this.scroll == null) {
        this.scroll = new BScroll(this.$refs.wrapper, {
          // 减少Dom更新
          scrollY: true,
          click: true,
          // adjustTime:50,
          mouseWheel: true,
          probeType: 3,
          tap: true,
        });
      
        let dataLength = this.dataList.length;
       
        this.scroll.on("scroll",
        //  debounce(
          (position) => {
          let ydistance = Math.abs(position.y)
          let wds = document.documentElement.scrollTop
          this.isShow = false
          //在container里时候
                if(this.screenWidth > 576){
                    this.blockBottom =
                  (1 / (dataLength - 1)) * Math.abs(position.y) +
                  (50 / (500 * (dataLength - 1))) * position.y;
                  let judgeDsi = 490;
                  this.dataList.forEach((item,index) => {
                    let count = index==0?1:index
                    let minDsi = count * judgeDsi;//400
                    let maxDsi = (count+1) * judgeDsi//800
                    // console.log("iii",ydistance,wds);
                    // console.log("iii-max-min",maxDsi,minDsi);
                    if(ydistance <= 490){
                      this.itemObj = {
                          timeLine : this.dataList[0].timeLine,
                          title : this.dataList[0].title,
                          sub : this.dataList[0].sub,
                      }
                   
                      if(0>ydistance && ydistance < 20){
                          document.documentElement.scrollTop = wds - 20
                        }
                     
                    }else if(ydistance>= minDsi && ydistance<=maxDsi){
                      this.itemObj = {
                          timeLine : item.timeLine,
                          title : item.title,
                          sub : item.sub,
                      }
                      if(ydistance > maxDsi){
                          document.documentElement.scrollTop = wds + 10
                        }
                    }
                   
                  });
                 
                    }else{
                this.blockBottom =
                (1 / (dataLength - 1)) * Math.abs(position.y) +
                (50 / (300 * (dataLength - 1))) * position.y;
                let judgeDsi = 290;
                  this.dataList.forEach((item,index) => {
                    let count = index==0?1:index
                    let minDsi = count * judgeDsi;//250
                    let maxDsi = (count+1) * judgeDsi//500
                    if(ydistance < 290){
                      this.itemObj = {
                          timeLine : this.dataList[0].timeLine,
                          title : this.dataList[0].title,
                          sub : this.dataList[0].sub,
                      }
                      if(0>ydistance && ydistance < 20){
                          document.documentElement.scrollTop = wds - 20
                        }
                    }else if(ydistance>= minDsi && ydistance<=maxDsi){
                      this.itemObj = {
                          timeLine : item.timeLine,
                          title : item.title,
                          sub : item.sub,
                      }
                      if(ydistance > maxDsi){
                          document.documentElement.scrollTop = wds + 10
                        }
                    }
                   
                  });
               
              }
        }
        // ,50)
        );
       
      }
    
      
    });
  },
  methods: {
    pushPage(title){
      let tabTop =""
      let tabTitle = ''
      switch (title) {
        case '“民航e政”APP':
          tabTitle = '民航e政'
          tabTop = '公共服务'
          break;
        case '适航管理系统（AMOS）':
          tabTitle = '适航管理系统（AMOS）'
          tabTop = '安全监管'
          break;
        case '民用无人驾驶航空器综合管理平台（UOM）':
          tabTitle = '民用无人驾驶航空器综合管理平台（UOM）'
          tabTop = '安全监管'
          break;
        case '民航政务信息系统整合共享项目':
          tabTitle = '民航政务信息系统整合共享项目'
          tabTop = '云平台'
          break;
        case '民航行政审批服务平台':
          tabTitle = '民航行政审批服务平台'
          tabTop = '公共服务'
          break;
        case '民航价格管理系统':
          tabTitle = '民航价格管理系统'
          tabTop = '市场监管'
          break;
        case '民航政务云服务平台':
          tabTitle = '民航政务云服务平台'
          tabTop = '云平台'
          break;
        case '民航综合统计信息系统':
          tabTitle = '民航综合统计信息系统'
          tabTop = '市场监管'
          break;
        case '民航行业监管执法系统SES':
          tabTitle = '民航行业监管执法系统(SES)'
          tabTop = '安全监管'
          break;
        case '民航局政府网站':
          tabTitle = '民航局政府网站'
          tabTop = '公共服务'
          break;
        case '民用机场安全监管ASOP':
          tabTitle = '民用机场安全监管(ASOP)'
          tabTop = '安全监管'
          break;
        case '飞行标准监督管理（FSOP）':
          tabTitle = '飞行标准监督管理(FSOP)'
          tabTop = '安全监管'
          break;
      
        default:
          break;
      }
      this.$router.push({
        path:'/e-gov/wisdom-gov',
        query:{
          tabTop:tabTop,
          title:tabTitle,
        }
      })
    },
   
    setReSize() {
      if (this.screenWidth >= 576) {
        // this.t_left = "calc(44.5% - 27.5px)";
        // (2*12/8+5)/(12*12/8)=44.4%
        this.t_left="calc(44.6% - 25px)"
      } else {
        this.t_left = "calc(50% - 25px)";
      }
    },
  },
};
</script>
<style>
@import "../../../assets/css/products.css";
</style>
<style lang="scss">
.products {
  
    margin: 0 auto;
  /* height: calc(800px); */
  background: #fff;
  padding: 2% 0 5%;
}

.container1 {
  width: 65%;
  margin: 0 auto;
  height: 500px;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  cursor: move;
}
.brow {
  height: 500px;
}
.verticalBar {
  width: 2px;
  height: 100%;
  margin: 0 auto;
  background-color: #eee;
  /* background-image:linear-gradient(to bottom right, rgb(191,191,191) , rgb(255,255,255)); */
}
.block {
  width: 50px;
  height: 50px;
  background: url("../../../assets/images/index/zdxm/plane-up.png") no-repeat;
  background-size: 100% 100%;
  position: absolute;
  /*left: calc(50% - 5px);*/
}
.brow .img-box {
   margin:auto ;
}

@media (max-width: 575px) {
  .products {
    /* height: auto; */
  }
  .container1 {
    height: 300px;
    width: 85%;
    overflow: hidden;
    background-color: #fff;
  }

  .brow{
    height: 300px;
  }
  .block {
    transform: scale(0.5, 0.5);
  }
  .yincang{
    height: 10px;
  }
  
  
  .brow .img-box {
    /* margin-bottom: 100px; */
  }
  .brow .img-box {
    img{
      width: 95%;
    }
    height: 250px;
    margin-bottom:50px;
  }

  .left_content {
    margin-top: 2%;
  }
  .timeLine {
    font-size: 30px;
    line-height: 1.2;
  }
  .title {
    
    font-size: 16px;
  }
  .sub {
    margin-top: 4%;
    margin-bottom: 10%;
    line-height: 2;
    text-indent: 2em;
    font-size: 14px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 14;
    line-clamp:14;
    -webkit-box-orient: vertical;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .left_content {
    margin-top: 4%;
  }
  .timeLine {
    font-size: 30px;
    line-height: 1;
  }
  .title {
    font-size: 18px;
  }
  .sub {
    margin-top: 2%;
    line-height: 2;
    font-size: 15px;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  
  .left_content {
    margin-top: 3%;
  }
  .timeLine {
    font-size: 34px;
    line-height: 1.2;
  }
  .title {
    font-size: 18px;
    line-height: 1.6;
  }
  .sub {
    margin-top: 2%;
    line-height: 2;
    font-size: 15px;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .left_content {
    margin-top: 3%;
  }
  .timeLine {
    font-size: 34px;
    line-height: 1.2;
  }
  .title {
    font-size: 20px;
  }
  .sub {
    margin-top: 1%;
    line-height: 2;
    font-size: 15px;
  }
}
@media (min-width: 1200px){
  
}
/* @media (min-width: 1200px) and (max-width: 1449px) {
  
} */
/* @media (min-width: 1500px) {
  .temp_box{
    top:5% !important;
  }
  
} */
</style>
